// -------------
// Init jquery, popper.js, & Bootstrap
// import jQuery from 'jquery';
// import Popper from 'popper.js';
// import bootstrap from 'bootstrap';

// try {
  // window.$ = jQuery;
  // window.Popper = Popper;
  // window.bootstrap = bootstrap;
// } catch (e) { console.log(e); }

// try {
  // window.Popper = require('popper.js').default;
  // window.$ = window.jQuery = require('jquery');
  // require('bootstrap');
// } catch (e) { console.log(e); }

// $('h1').css('color', 'green')

$('#toggle-mobile-nav').on('hide.bs.dropdown', () => {
  $('.icon-header-close').addClass('icon-menu');
  $('.icon-header-close').removeClass('icon-header-close');
});
